"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _mqtt = require("@/api/mqtt/mqtt");
var _default = {
  components: {},
  data: function data() {
    return {
      loading: true,
      searchForm: {
        command: 'cabinetOpenDoor',
        terminal_no: '2350000009',
        warehouse_no: '1'
      },
      commandList: [{
        label: '充电开',
        key: 'cabinetChargeOn'
      }, {
        label: '充电关',
        key: 'cabinetChargeOff'
      }, {
        label: '电池仓开门',
        key: 'cabinetOpenDoor'
      }, {
        label: '查询上报信息',
        key: 'cabinetQueryInfo'
      }
      // {
      //     label: '设置换电柜屏幕',
      //     key: 'setCabinetOSD',
      // },
      // {
      //     label: '查询电表度数',
      //     key: 'electricMeterKWH',
      // },
      ],

      result: ''
    };
  },
  watch: {
    'searchForm.command': function searchFormCommand(val) {
      this.result = '';
    }
  },
  mounted: function mounted() {},
  methods: {
    commandTest: function () {
      var _commandTest2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var isSend,
          param,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isSend = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
                // console.log('commandTest')
                param = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), {}, {
                  is_send: isSend
                });
                _context.next = 4;
                return (0, _mqtt.commandTest)(param).catch(function (e) {});
              case 4:
                res = _context.sent;
                console.log('commandTest', res);
                this.result = res;
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function commandTest() {
        return _commandTest2.apply(this, arguments);
      }
      return commandTest;
    }(),
    test: function test() {}
  }
};
exports.default = _default;